import { render, staticRenderFns } from "./NavBar-3.vue?vue&type=template&id=bd3fa904&scoped=true&"
import script from "./NavBar-3.vue?vue&type=script&lang=js&"
export * from "./NavBar-3.vue?vue&type=script&lang=js&"
import style0 from "./NavBar-3.vue?vue&type=style&index=0&id=bd3fa904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3fa904",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VMenu,VTextField})
